<template src='./popUp.html'>
</template>
<script>
export default {

    beforeUpdate() {
    },
    props: {
        informacionFormulariosLlenos: {
            type: Array,
            required: true
        }
    }
}
</script>
<style lang="scss" scoped src='./popUp.scss'>
</style>



// WEBPACK FOOTER //
// src/components/PopUp/popUp.vue